import { render, staticRenderFns } from "./Impact.vue?vue&type=template&id=28e0066e&scoped=true"
import script from "./Impact.vue?vue&type=script&lang=js"
export * from "./Impact.vue?vue&type=script&lang=js"
import style0 from "./Impact.vue?vue&type=style&index=0&id=28e0066e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0066e",
  null
  
)

export default component.exports